import PropTypes from 'prop-types';
import { getContext } from 'recompose';

export default getContext({
  kiosk: PropTypes.bool.isRequired,
});



// WEBPACK FOOTER //
// ./src/app/hoc/WithKioskProp.js